import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, provideHttpClient } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { AuthLayoutModule } from './layouts/auth-layout/auth-layout.module';
import { MainLayoutModule } from './layouts/main-layout/main-layout.module';
import { SharedModule } from './shared/shared.module';
import { FormsModule } from '@angular/forms';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { CookieService } from 'ngx-cookie-service';
import { MyPreset } from './mytheme';
import { DatePipe } from '@angular/common';

// Import interceptors
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { EncryptionInterceptor } from './core/interceptors/encryption.interceptor';

// Import core services
import { AuthService } from './core/services/auth-service/auth.service';
import { SecurityService } from './core/services/auth-service/security.service'; // Add this
import { ApiService } from './core/services/api-service/api.service';
import { NotificationService } from './core/services/notification-service/notification.service';
import { PopupService } from './core/services/popup-service/popup.service';


import { SocketService } from './core/services/socket-service/socket.service';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    BrowserAnimationsModule,
    HttpClientModule,
    RouterModule.forRoot([]),
    AppRoutingModule,
    CoreModule,
    AuthLayoutModule,
    MainLayoutModule,
    SharedModule.forRoot(),
    FormsModule,

  ],
  providers: [
    SocketService,
     {
      provide: HTTP_INTERCEPTORS,
      useClass: EncryptionInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    // Core Services (Singletons)
    AuthService,
    SecurityService, // Add this
    ApiService,
    CookieService,
    NotificationService,
    PopupService,
    provideAnimationsAsync(),
    provideHttpClient(),
    CookieService,
    DatePipe,
    providePrimeNG({
      theme: {
        preset: MyPreset,
        options: {
          darkModeSelector: false || 'none',
          cssLayer: {
            name: 'primeng',
            order: 'tailwind-base, primeng, tailwind-utilities'
        }
        }
      }
    })

  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
